"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const next_components_icon_label_n_1 = __importStar(require("@gerenciatd/next.components.icon-label-n"));
const next_components_button_n_1 = __importStar(require("@gerenciatd/next.components.button-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const utils_1 = require("../../ModalsContent/utils");
const utils_2 = require("./utils");
const constants_1 = require("../../constants");
const Searcher_1 = __importDefault(require("./Searcher"));
class MoreOptions extends react_1.Component {
    constructor() {
        super(...arguments);
        /**
         * Manejador de propiedades css del SvgIconLabel
         * @param {string} segment segmento
         * @returns {object} propiedades css
         */
        this.getIconLabelProps = ({ segment, selected = false, isGestor = false, isPriority = false, }) => {
            let res = {};
            switch (segment) {
                case constants_1.EMPRESAS:
                    res = {
                        iconColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6,
                        labelColor: next_components_icon_label_n_1.ICON_COLOR.GREY_4,
                        iconSize: 20,
                        labelSize: 14,
                    };
                    if (selected) {
                        res = Object.assign(Object.assign({}, res), { iconColor: next_components_icon_label_n_1.ICON_COLOR.BLUE, labelColor: next_components_icon_label_n_1.ICON_COLOR.BLUE });
                    }
                    break;
                default:
                    res = {
                        iconColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6,
                        labelColor: next_components_icon_label_n_1.ICON_COLOR.GREY_4,
                        iconSize: 20,
                        labelSize: 14,
                    };
                    if (isPriority) {
                        res = {
                            iconColor: next_components_icon_label_n_1.ICON_COLOR.WHITE,
                            labelColor: next_components_icon_label_n_1.ICON_COLOR.WHITE,
                        };
                    }
                    if (selected && isGestor) {
                        res = Object.assign(Object.assign({}, res), { iconColor: next_components_icon_label_n_1.ICON_COLOR.BLUE, labelColor: next_components_icon_label_n_1.ICON_COLOR.BLUE });
                    }
                    if (selected && !isGestor) {
                        res = Object.assign(Object.assign({}, res), { iconColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6, labelColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6 });
                    }
                    break;
            }
            return res;
        };
        /**
         * Crea el elemento clicable y define su comportamiento al cick (link o modal)
         * @param {string} actionId id de la accion
         * @param {object} modalProps propiedades del modal
         * @param {object} props propiedadesdel componente
         * @returns {jsx}
         */
        this.returnDependsOnActionId = (actionId, modalProps, props, addModal) => {
            const { userType, isGestor, isPriority, segment, fullName, showNotificationsIcon, badget, } = this.props;
            const { svgId, taggingInfo, name, link, text, selected } = props;
            switch (actionId) {
                case constants_1.TITLE_BAR_IDS.TELCO.OUT: {
                    const label = text || name;
                    return (react_1.default.createElement(next_components_custom_link_1.default, { key: actionId, href: `https://www.movistar.es${link}` ||
                            '/cliente/areaprivada/#/facturas', forceExternal: true, title: label, ariaLabel: label, className: `mOItem ${actionId} ${userType ? 'logged' : 'nologged'}`, taggingInfo: taggingInfo },
                        react_1.default.createElement(next_components_icon_label_n_1.default, { id: svgId, className: "iconMO", labelPosition: "left", label: label, segment: segment, iconColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6, labelColor: next_components_icon_label_n_1.ICON_COLOR.GREY_6, labelFont: next_components_icon_label_n_1.ICON_LABEL_FONT_TYPE.REGULAR, iconSize: 16, labelSize: 14 })));
                }
                case constants_1.TITLE_BAR_IDS.TELCO.SHOP:
                    const currentOnClick = !link
                        ? () => (0, utils_1.handleModal)(actionId, modalProps, props, addModal)
                        : null;
                    let label = text || name;
                    let labelPosition = 'left';
                    if (isGestor && actionId === constants_1.TITLE_BAR_IDS.TELCO.PROFILE) {
                        label = fullName;
                        labelPosition = 'right';
                    }
                    return (react_1.default.createElement(next_components_custom_link_1.default, { key: actionId, ariaLabel: label, title: label, component: actionId !== constants_1.TITLE_BAR_IDS.TELCO.SHOP ? 'button' : 'a', href: link, forceExternal: true, onClick: currentOnClick, className: `mOItem ${actionId} ${userType ? 'logged' : 'nologged'}`, taggingInfo: taggingInfo },
                        react_1.default.createElement(next_components_icon_label_n_1.default, Object.assign({ id: svgId, className: "iconMO", labelPosition: labelPosition, label: label, segment: segment }, this.getIconLabelProps({
                            segment,
                            selected,
                            isGestor,
                            isPriority,
                        })))));
                case constants_1.TITLE_BAR_IDS.TELCO.SEARCH: {
                    const currentOnClick = !link
                        ? () => (0, utils_1.handleModal)(actionId, modalProps, props, addModal)
                        : null;
                    let label = text || name;
                    let labelPosition = 'left';
                    if (isGestor && actionId === constants_1.TITLE_BAR_IDS.TELCO.PROFILE) {
                        label = fullName;
                        labelPosition = 'right';
                    }
                    const IconLauncher = (react_1.default.createElement(next_components_custom_link_1.default, { key: actionId, ariaLabel: label, title: label, component: actionId !== constants_1.TITLE_BAR_IDS.TELCO.SHOP ? 'button' : 'a', href: link, forceExternal: true, onClick: currentOnClick, className: `mOItem ${actionId} ${userType ? 'logged' : 'nologged'}`, taggingInfo: taggingInfo },
                        react_1.default.createElement(next_components_icon_label_n_1.default, Object.assign({ id: svgId, className: "iconMO", labelPosition: labelPosition, label: label, segment: segment }, this.getIconLabelProps({
                            segment,
                            selected,
                            isGestor,
                            isPriority,
                        })))));
                    return (react_1.default.createElement(Searcher_1.default, { key: "searcherLauncher", handleModal: ({ customModalProps, }) => {
                            (0, utils_1.handleModal)(actionId, Object.assign(Object.assign({}, modalProps), customModalProps), Object.assign(Object.assign({}, props), { visibleInput: true }), addModal);
                        }, needOpenModalResults: true, IconLauncher: IconLauncher }));
                }
                case constants_1.TITLE_BAR_IDS.TELCO.PROFILE: {
                    let label = text || name;
                    let labelPosition = 'left';
                    if (isGestor && actionId === constants_1.TITLE_BAR_IDS.TELCO.PROFILE) {
                        label = fullName;
                        labelPosition = 'right';
                    }
                    return (react_1.default.createElement(next_components_custom_link_1.default, { key: actionId, component: "a", ariaLabel: label, title: label, href: `${link}` || null, forceExternal: true, className: `mOItem ${actionId} ${userType ? 'logged' : 'nologged'}`, taggingInfo: taggingInfo },
                        react_1.default.createElement(next_components_icon_label_n_1.default, Object.assign({ id: svgId, className: "iconMO", labelPosition: labelPosition, label: label, segment: segment }, this.getIconLabelProps({
                            segment,
                            selected,
                            isGestor,
                            isPriority,
                        })))));
                }
                case constants_1.TITLE_BAR_IDS.TELCO.NOTIFICATIONS: {
                    if (!showNotificationsIcon) {
                        return null;
                    }
                    const currentOnClick = !link
                        ? () => (0, utils_1.handleModal)(actionId, modalProps, props, addModal)
                        : null;
                    const label = text || name;
                    return (react_1.default.createElement(next_components_custom_link_1.default, { key: actionId, ariaLabel: label, title: label, href: link ? `https://www.movistar.es${link}` : '', forceExternal: true, onClick: currentOnClick, className: `mOItem ${actionId} ${userType ? 'logged' : 'nologged'}`, taggingInfo: taggingInfo },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement(next_components_icon_label_n_1.default, Object.assign({ id: svgId, segment: segment, label: label, className: "iconMO", labelPosition: "left" }, this.getIconLabelProps({
                                segment,
                                selected,
                                isGestor,
                                isPriority,
                            }))),
                            badget && react_1.default.createElement("span", { className: "dotBadge bounce" }))));
                }
                case 'login':
                    // check if we are logged
                    if (!userType && segment === constants_1.PARTICULARES && !isGestor) {
                        return (react_1.default.createElement(next_components_button_n_1.default, { key: actionId, height: next_components_button_n_1.BUTTON_HEIGHT.SMALL, backgroundColor: "primary", label: name, className: `mOItem ${actionId}`, onClick: () => (0, utils_1.handleModal)(actionId, modalProps, props, addModal), taggingInfo: taggingInfo, segment: segment }));
                    }
                    return null;
                default:
                    return null;
            }
        };
    }
    render() {
        let { options } = this.props;
        const { addModal } = this.props;
        const { userType, isPriority, modalProps } = this.props;
        if (!options || options.length === 0) {
            return null;
        }
        options = (0, utils_2.setSearchOnFirstPlace)(options);
        const cssLogged = userType ? ' logged' : '';
        const cssPriority = isPriority ? ` ${constants_1.PRIORITY}` : '';
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: `MoreOptions${cssLogged}${cssPriority}` }, options.map((optionItem) => {
                let id = 'none';
                if (optionItem && optionItem.action && optionItem.action.id) {
                    ({ id } = optionItem.action);
                }
                return this.returnDependsOnActionId(id, modalProps, optionItem, addModal);
            }))));
    }
}
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(MoreOptions);
//# sourceMappingURL=index.js.map